import MiniMasonry from "minimasonry";

export function masonry(containerSelector) {
  let containers = document.querySelectorAll(containerSelector);
  containers.forEach((container) => {
    new MiniMasonry({
      container: container,
      gutter: 0,
    });
  });
}
